export default function Navbar({ name, links }) {
  const [first, ...rest] = name.split(" ");
  return (
    <nav>
      <div className="nav-logo">
        {first} <em style={{ fontStyle: "italic" }}>{rest.join(" ")}</em>
      </div>
      <ul className="nav-links">
        {links.map((link) => (
          <li key={link.href}>
            <a href={link.href}>{link.label}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
